import './MainAbout.css';
import about_img from '../images/ss.webp';
import leaf_left from '../images/side_leaf.webp'; // <-- your leaf image
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";


export default function MainAbout() {
  

  useEffect(() => {
  Aos.init({
    duration: 1000,      // animation duration
    easing: "ease-in-out",
    once: true,          // animation happens only once
    offset: 100,         // offset from the trigger point
  });

  Aos.refresh(); // optional but recommended
}, []);
  return (
    <section className="container-fluid  position-relative about-section" style={{zIndex: 5 }}>

      {/* FLOATING LEAF LEFT */}
      <img
        src={leaf_left}
        alt="leaf"
        className="about-floating-leaf"
      />

      <div className="container">
        <div className="row align-items-center g-5 pt-5">

          {/* LEFT IMAGE */}
          <div className="col-lg-6 text-center"  data-aos="zoom-in">
            <img
              src={about_img}
              alt="Ayurveda"
              className="img-fluid about-main-img" style={{zIndex:"0",}}
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6"  data-aos="zoom-in-up" style={{marginTop:'-5%'}}>
            <p className="text-success fw-semibold mb-2">OUR STORY</p>

            <h2 className="fw-bold mb-3 head-font">
             The Ayurvedic Way of Being
            </h2>

            <p className="text-muted mb-4 para-font justify-text ">
             Ayur Moksha is here with a vision to demonstrate how traditional Ayurveda can support and restore balance in today’s fast paced life through authentic healing practices. Nestled on the banks of a gently flowing river and surrounded by lush, fragrant gardens, it offers a serene Ayurvedic retreat. We provide complete Ayurvedic healthcare from rejuvenation and detox therapies to postnatal care and holistic treatments for chronic conditions rooted in ancient wisdom and traditional practices. The gentle river breeze, rustling leaves, and vibrant greenery create a profound sense of peace, while our gardens, home to carefully cultivated medicinal herbs, ensure the purity and potency of every treatment. Our aesthetically designed in-patient (IP) facility provides comfort and healing for extended stays, and our guided yoga sessions overlooking the river help restore flexibility, calmness, and inner balance.
            </p>

            <div className="row mb-4">
              
            </div>

            {/* <button className="btn btn-success px-4 py-2 mb-5">Explore</button> */}
          </div>

        </div>
      </div>
    </section>
  );
}
